/* eslint-disable
    func-names,
    no-multi-assign,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PermissionsBase from "permissions/permissions_base";

let CommentsModeratorPermissions;

export default CommentsModeratorPermissions = (function () {
  CommentsModeratorPermissions = class CommentsModeratorPermissions extends PermissionsBase {
    static initClass() {
      // permissions for moderator
      this.prototype.permissions = {
        _renderModeratorControls: true,
        _renderCommentRecommendsView: true,
        _renderContentSubscriptionIndicatorView: true,
        _renderNewCommentButtonView: true,
        _renderReportButton: true,
        _renderReplyButton: true,
      };
    }
  };
  CommentsModeratorPermissions.initClass();
  return CommentsModeratorPermissions;
}());
